import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{class:_vm.gutters ? '' : 'pa-0 ma-0',attrs:{"selectable":""}},[_c(VListItemContent,[_c(VListItemSubtitle,{staticClass:"overline"},[_vm._v(_vm._s(_vm.title))]),_c(VListItemTitle,{staticClass:"info-item-title"},[_c('span',[_vm._v(_vm._s(_vm.subtitle))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }